import { Popup } from "components/popups/Popup";
import Button from "components/shared/button";
import { useConfirmationPopup } from "components/shared/popup/confirmationPopup";
import { useEffect } from "react";
import { useDeleteEtudeDataMutation } from "store/api";
import useTranslation from "utils/hooks/useTranslation";

export const DeletePopup: React.FC<{
  closePopup: () => void;
  network: any;
  selectedRowIDs: number[];
  etudesListData: any[];
  setEtudesListDataCallback: React.Dispatch<React.SetStateAction<any[]>>;
  refetchEtudeListData: () => void;
}> = ({
  closePopup,
  network,
  selectedRowIDs,
  setEtudesListDataCallback,
  refetchEtudeListData,
}) => {
  const { t } = useTranslation();
  const { open, popup: confirmationPopup } = useConfirmationPopup();
  const [deleteEtude, { isSuccess, isLoading }] = useDeleteEtudeDataMutation();

  const onDelete = async () => {
    try {
      const result: any = await deleteEtude({
        selected: selectedRowIDs,
        code: network?.code,
      });

      if (result.error) {
        throw new Error(result.error.data.title);
      }

      setEtudesListDataCallback((prev: any[] = []) =>
        prev.filter((item) => !selectedRowIDs.includes(item.id))
      );

      closePopup();
      refetchEtudeListData();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  const abortController = new AbortController();
  const onCancel = () => {
    abortController.abort();
    closePopup();
  };

  useEffect(() => {
    open({
      title: t("FO_STUDIES_DELETE_STUDY"),
      message: t("FO_STUDIES_DELETE_WANT"),
      positiveCallback: onDelete,
      positiveButtonText: t("FO_SIM_DELETE"),
      positiveButtonIcon: "delete",
      negativeButtonText: t("cancel"),
      negativeCallBack: closePopup,
    });
  }, []);

  return (
    <>
      {!isSuccess ? (
        <>{confirmationPopup}</>
      ) : (
        <Popup title={t("FO_STUDIES_DELETE_STUDY")} fixSize="small">
          <group
            data-direction="column"
            data-gap="20"
            data-space="20"
            data-height="autofit"
            data-length="450"
          >
            <group data-space="50" data-gap="10" data-fit="1">
              <group
                data-space="10"
                data-radius="40"
                data-background="success-color-light"
                data-width="auto"
                data-position="center"
              >
                <icon data-icon-size="medium" data-color="success-color-dark">
                  done
                </icon>
              </group>
              <group>
                <text data-position="center">
                  {t("FO_STUDIES_DELETE_DELETED")}
                </text>
              </group>
            </group>
            <Button accent large onClick={closePopup}>
              {t("FO_BUTTON_CLOSE")}
            </Button>
          </group>
        </Popup>
      )}

      {isLoading && (
        <Popup title={t("FO_STUDIES_DELETE_STUDY")} fixSize="small">
          <group
            data-direction="column"
            data-gap="20"
            data-space="20"
            data-height="autofit"
            data-length="450"
          >
            <group data-space="50" data-gap="10" data-fit="1">
              <group
                data-space="10"
                data-radius="40"
                data-background="success-color-light"
                data-width="auto"
                data-position="center"
              >
                <icon data-icon-size="medium" data-color="indigo">
                  loading
                </icon>
              </group>
              <group>
                <text data-position="center">
                  {t("FO_STUDIES_DELETE_INPROGRESS")}
                </text>
              </group>
            </group>
            <Button accent large onClick={onCancel}>
              {t("cancel")}
            </Button>
          </group>
        </Popup>
      )}
    </>
  );
};
